import React from 'react'
import MainTitle from '../../components/admin/MainTitle'

function AccountAddPage() {
    return (
        <div className='pt-20'>
            <MainTitle content={"Account Add"} button={"목록"} path={"../account"} />
        </div>
    )
}

export default AccountAddPage